module.exports = __webpack_public_path__ + "static/media/needs-10.92ab7772.png";